import { createApp, onMounted } from 'vue';
import App from './App.vue';

import iModal from './components/lib/modal/Modal.vue';
import iIcon from './components/lib/icon/Icon.vue';
import iButton from './components/lib/button/Button.vue';
import imperiaTipTapEditor from './components/imperiaTipTapEditor.vue';

import * as TiptapCore from '@tiptap/core';

// Ensure TIPTAP_EDITOR is only defined in the browser environment
if (typeof window !== 'undefined') {
  if (!window.TIPTAP_EDITOR) window.TIPTAP_EDITOR = {};  // Initialize if not already present
  window.TIPTAP_EDITOR.TiptapCore = TiptapCore;  // Expose TiptapCore globally
}

declare global {
  interface Window {
    TIPTAP_EDITOR?: any;
  }
  interface HTMLElement {
    mountTiptap: (config: Object) => void;
  }
}

// Define mountTiptap on HTMLElement
HTMLElement.prototype.mountTiptap = function (config) {
  const editorApp = createApp(imperiaTipTapEditor, { config });
  editorApp.directive('dropdown-focus', {
    updated(el, binding) {
      const { index, activeIndex } = binding.value || {};

      if (index === activeIndex) {
        const focusTarget = el.querySelector('a') || el;
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus();
        }
      }
    }
  });

  editorApp.component('iModal', iModal);
  editorApp.component('iIcon', iIcon);
  editorApp.component('iButton', iButton);

  editorApp.mount(this);
};